// import React, { useState } from "react";
// import {
//   Box,
//   Paper,
//   ClickAwayListener,
//   Checkbox,
//   MenuItem,
//   IconButton,
// } from "@mui/material";
// import arrow from "../assets/arrow.svg";
// import crossselect from "../assets/crossselect.svg";
// import CustomText, { textStyles } from "./CustomText";
// import { useTranslation } from "react-i18next";

// const WorkersMultiSelectDropdown = ({ label, name, values, onChange, options }) => {
//   const [open, setOpen] = useState(false);
//   const { t } = useTranslation();

//   // normalize options: always convert into {label, value, email}
//   const normalizedOptions = options.map((opt) =>
//     typeof opt === "string" ? { label: opt, value: opt, email: "" } : opt
//   );

//   const handleToggle = (option) => {
//     const updated = values.includes(option.value)
//       ? values.filter((item) => item !== option.value)
//       : [...values, option.value];

//     onChange({ target: { name, value: updated } });
//   };

//   return (
//     <ClickAwayListener onClickAway={() => setOpen(false)}>
//       <Box sx={{ position: "relative", mb: 0.5 }}>
//         <CustomText
//           sx={{
//             ...textStyles.body5,
//             color: "#6B778C",
//             pt: 1.2,
//             textAlign: "left",
//           }}
//         >
//           {label}
//         </CustomText>

//         <Box
//           onClick={() => setOpen(!open)}
//           sx={{
//             height: 38,
//             border: "2px solid #091E4224",
//             borderRadius: "6px",
//             px: 2,
//             fontSize: 14,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             cursor: "pointer",
//             backgroundColor: "#fff",
//             mt: 0.5,
//           }}
//         >
//           <span style={{ color: values.length ? "#172B4D" : "#A0A0A0" }}>
//             {t("select")}
//           </span>
//           <img src={arrow} alt="arrow" style={{ width: 18 }} />
//         </Box>

//         {open && (
//           <Paper
//             sx={{
//               mt: 1,
//               boxShadow: 1,
//               borderRadius: 1,
//               position: "absolute",
//               zIndex: 10,
//               width: "100%",
//               p: 1,
//               backgroundColor: "white",
//               maxHeight: 150,
//               overflowY: "auto",
//             }}
//           >
//             {normalizedOptions.map((opt) => (
//               <MenuItem
//                 key={opt.value}
//                 onClick={() => handleToggle(opt)}
//                 sx={{
//                   gap: 1,
//                   px: 1,
//                   py: 0.5,
//                   fontSize: "15px",
//                   fontFamily: "Poppins, sans-serif",
//                   fontWeight: 400,
//                   lineHeight: 1.2,
//                   minHeight: "unset",
//                   display: "flex",
//                   flexDirection: "column", // Stack name and email
//                   alignItems: "flex-start", // Align to the left
//                 }}
//               >
//                 <Checkbox
//                   checked={values.includes(opt.value)}
//                   size="small"
//                   sx={{ p: 0.5 }}
//                 />
//                 <span>{opt.label}</span>
//                 {opt.email && (
//                   <span style={{ fontSize: "0.9em", color: "#888" }}>
//                     {opt.email}
//                   </span>
//                 )}
//               </MenuItem>
//             ))}
//           </Paper>
//         )}

//         {values.length > 0 && (
//           <Box sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 0.8 }}>
//             {values.map((val) => {
//               const option = normalizedOptions.find((o) => o.value === val);
//               return (
//                 <Box
//                   key={val}
//                   sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     px: 0.8,
//                     py: 1,
//                     backgroundColor: "#579DFF",
//                     borderRadius: "6px",
//                     fontSize: "14px",
//                     color: "#09326C",
//                     fontWeight: 500,
//                   }}
//                 >
//                   {option ? option.label : val}
//                   <IconButton
//                     size="small"
//                     onClick={() => handleToggle(option || { value: val })}
//                     sx={{ ml: 0.3, p: 0 }}
//                   >
//                     <img
//                       src={crossselect}
//                       alt="remove"
//                       style={{ width: 16, height: 16 }}
//                     />
//                   </IconButton>
//                 </Box>
//               );
//             })}
//           </Box>
//         )}
//       </Box>
//     </ClickAwayListener>
//   );
// };

// export default WorkersMultiSelectDropdown;


import React, { useState } from "react";
import {
  Box,
  Paper,
  ClickAwayListener,
  Checkbox,
  MenuItem,
  IconButton,
} from "@mui/material";
import arrow from "../assets/arrow.svg";
import crossselect from "../assets/crossselect.svg";
import CustomText, { textStyles } from "./CustomText";
import { useTranslation } from "react-i18next";

const WorkersMultiSelectDropdown = ({
  label,
  name,
  values,
  onChange,
  options,
  enableSearch = false,
  isSingleSelect = false,
}) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState(""); // ✅ for search
  const { t } = useTranslation();

  // normalize
  const normalizedOptions = options.map((opt) =>
    typeof opt === "string" ? { label: opt, value: opt, email: "" } : opt
  );

  // filter options on search
  const filteredOptions = normalizedOptions.filter((opt) =>
    opt.label.toLowerCase().includes(search.toLowerCase()) ||
    opt.email?.toLowerCase().includes(search.toLowerCase())
  );

  const handleToggle = (option) => {
    const updated = values.includes(option.value)
      ? values.filter((item) => item !== option.value)
      : isSingleSelect
      ? [option.value]
      : [...values, option.value];

    onChange({ target: { name, value: updated } });
    if (isSingleSelect) setOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Box sx={{ position: "relative", mb: 0.5 }}>
        <CustomText
          sx={{
            ...textStyles.body5,
            color: "#6B778C",
            pt: 1.2,
            textAlign: "left",
          }}
        >
          {label}
        </CustomText>

        <Box
          onClick={() => setOpen(!open)}
          sx={{
            height: 38,
            border: "2px solid #091E4224",
            borderRadius: "6px",
            px: 2,
            fontSize: 14,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            cursor: "pointer",
            backgroundColor: "#fff",
            mt: 0.5,
          }}
        >
          <span style={{ color: values.length ? "#172B4D" : "#A0A0A0" }}>
            {t("select")}
          </span>
          <img src={arrow} alt="arrow" style={{ width: 18 }} />
        </Box>

        {open && (
          <Paper
            sx={{
              mt: 1,
              boxShadow: 1,
              borderRadius: 1,
              position: "absolute",
              zIndex: 10,
              width: "100%",
              p: 1,
              backgroundColor: "white",
              maxHeight: 200,
              overflowY: "auto",
            }}
          >
            {/* 🔍 Search Input */}
            {enableSearch && (
              <input
                type="text"
                placeholder={t("search")}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{
                  width: "100%",
                  padding: "8px 10px",
                  marginBottom: 8,
                  border: "1px solid #ccc",
                    fontFamily: 'Poppins, sans-serif',
                  borderRadius: 6,
                  fontSize: 14,
                }}
              />
            )}

            {filteredOptions.length > 0 ? (
              filteredOptions.map((opt) => (
          <MenuItem
  key={opt.value}
  onClick={() => handleToggle(opt)}
  sx={{
    gap: 1,
    px: 1,
    py: 0.5,
    fontSize: "15px",
    fontFamily: "Poppins, sans-serif",
    minHeight: "unset",
    display: "flex",             // row
    flexDirection: "row",        // row layout
    alignItems: "center",        // center align row
  }}
>
  {!isSingleSelect && (
    <Checkbox
      checked={values.includes(opt.value)}
      size="small"
      sx={{ p: 0.5 }}
    />
  )}

  {/* Text content in COLUMN */}
  <Box sx={{ display: "flex", flexDirection: "column", ml: 1 }}>
    <span>{opt.label}</span>
    {opt.email && (
      <span style={{ fontSize: "0.9em", color: "#888" }}>
        {opt.email}
      </span>
    )}
  </Box>
</MenuItem>

              ))
            ) : (
              <Box sx={{ p: 1, textAlign: "center", color: "#999" }}>
                {t("noResults")}
              </Box>
            )}
          </Paper>
        )}

        {/* Selected Chips */}
        {values.length > 0 && (
          <Box sx={{ mt: 1, display: "flex", flexWrap: "wrap", gap: 0.8 }}>
            {values.map((val) => {
              const option = normalizedOptions.find((o) => o.value === val);
              return (
                <Box
                  key={val}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    px: 0.8,
                    py: 1,
                    backgroundColor: "#579DFF",
                    borderRadius: "6px",
                    fontSize: "14px",
                    color: "#09326C",
                    fontWeight: 500,
                  }}
                >
                  {option ? option.label : val}
                  <IconButton
                    size="small"
                    onClick={() => handleToggle(option || { value: val })}
                    sx={{ ml: 0.3, p: 0 }}
                  >
                    <img
                      src={crossselect}
                      alt="remove"
                      style={{ 
                        width: 16, 
                        height: 16,
                        filter: "brightness(0) invert(1)"
                      }}
                    />
                  </IconButton>
                </Box>
              );
            })}
          </Box>
        )}
      </Box>
    </ClickAwayListener>
  );
};

export default WorkersMultiSelectDropdown;
